import { Controller } from "@hotwired/stimulus"

let cimToolsSessionsDatatable;
let cimToolsSessionsFixedHeader;

export default class extends Controller {
  static values = { pageLength: Number }

  connect() {
    const normalColumns = [
      {"data": "user_name"},
      {"data": "user_company"},
      {"data": "user_department"},
      {"data": "user_title"},
      {"data": "operation"},
      {"data": "ip_mac_address"},
      {"data": "created_at"},
      {"data": "updated_at"}
    ];

    cimToolsSessionsDatatable = $('#cim-tools-sessions-datatable').DataTable({
      "processing": true,
      "serverSide": true,
      "pageLength": this.pageLengthValue,
      "autoWidth": false,
      "ajax": $('#cim-tools-sessions-datatable').data('source'),
      "pagingType": "full_numbers",
      "columns": normalColumns,
      "order": [[ 3, 'DESC' ]],
      stateSave: true,
      stateSaveCallback: function(settings, data) {
          localStorage.setItem('DataTables_cim-tools-sessions', JSON.stringify(data));
        },
      stateLoadCallback: function() {
        return JSON.parse(localStorage.getItem('DataTables_cim-tools-sessions'));
        }
    });
    cimToolsSessionsFixedHeader = new $.fn.dataTable.FixedHeader(cimToolsSessionsDatatable, {
      header: true,
      footer: false,
      footerOffset: 0
    });
  }

  disconnect() {
    cimToolsSessionsFixedHeader.destroy();
    cimToolsSessionsDatatable.destroy();
  }
}
